export default __webpack_public_path__ + "static/media/image3.36ffe22d.png";